import React from 'react';
import { StyledChevron } from '../BorderControlRequirement.styles';

const ChevronIconClose = () => (
  <StyledChevron
    data-testid="chevronIcon"
    data-cy="chevronIcon"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.20993 4.05998L15.8875 11.7376C16.0375 11.8875 16.0375 12.1275 15.8875 12.2774C15.7676 12.3974 15.5276 12.4274 15.3477 12.2774L8.59981 6.69916C8.26991 6.36926 7.73008 6.36926 7.40019 6.69916L0.652296 12.3074C0.472352 12.4574 0.232428 12.4274 0.112465 12.3074C-0.0374889 12.1575 -0.037489 11.9175 0.112465 11.7676L7.79007 4.08997C7.85005 4.02999 7.91003 4 8 4C8.08997 4 8.14995 4 8.20993 4.05998Z"
      fill="#1C1C1A"
    />
  </StyledChevron>
);

export default ChevronIconClose;
